import StatusFilter from './StatusFilter'

const SEVERITY_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'critical', label: 'Critical' },
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
]

interface BugSeverityFilterProps {
  value: string
  onChange: (value: string) => void
}

export default function BugSeverityFilter({ value, onChange }: BugSeverityFilterProps) {
  return (
    <StatusFilter
      value={value}
      onChange={onChange}
      options={SEVERITY_OPTIONS}
      label="Severity"
      analyticsPrefix="bug-severity-filter"
      testId="severity-filter"
    />
  )
}
